import * as React from "react";
import Error from "next/error";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {useArticles} from "@/lib/api";
import {Spinner} from "components/Spinner";
import {NewsIndexCard} from "components/news/NewsIndexCard";
import {NewsCard} from "components/news/NewsCard";
import {useRouter} from "next/router";
import {ContentContainer} from "@/components/ContentContainer";

export default function NewsIndex({}) {
    const router = useRouter();
    const {category} = router.query;
    const {articles, isLoading, isError} = useArticles(category);

    if (isLoading) return <Spinner/>;
    if (isError) return <Error/>;

    return (
        <ContentContainer headline="News">
            <Grid container justifyContent="center">
                {articles?.articles?.map((article) => (
                    <Grid
                        key={article.slug}
                        item
                        xs={12}
                        sx={{
                            "&.MuiGrid-root": {
                                py: 3,
                                "&:not(:last-of-type)": {
                                    borderBottom: "1px solid black",
                                },
                                "&:first-of-type": {
                                    pt: 0,
                                },
                            },
                        }}
                    >
                        <NewsIndexCard key={article.slug} article={article}/>
                        <Box sx={{display: {xs: "block", md: "none"}}}>
                            <NewsCard key={article.slug} article={article}/>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </ContentContainer>
    );
}
